// Onde a pessoa trabalhou no dia — duas caixas de marcar (pedido do Lucas,
// 30/09/2026): "Home office" (de casa ou remoto) e "Campo". São independentes:
// manhã em casa e tarde em campo marca as duas; nenhuma marcada = escritório.
//
// Cada clique manda só a caixa que mudou (a outra não vai no pedido), para
// dois cliques seguidos não se desfazerem. Usado na grade e no calendário da
// semana; o atalho do cabeçalho tem a sua versão em HTML puro.
import { Checkbox, Tooltip } from 'antd';
import type { MarcaLocal } from './horasUtils';

export default function LocalDoDia({ remoto, campo, onMudar, emLinha }: {
  remoto: boolean;
  campo: boolean;
  onMudar: (marca: MarcaLocal, valor: boolean) => void;
  /** Lado a lado (cabeçalho largo) em vez de empilhado (coluna estreita). */
  emLinha?: boolean;
}) {
  const caixa = { fontSize: 11, marginInlineStart: 0, whiteSpace: 'nowrap' as const };
  return (
    <div
      // O calendário trata o toque/arraste na coluna como "lançar horas":
      // o clique na caixa não pode subir até lá.
      onPointerDown={(e) => e.stopPropagation()}
      style={{
        display: 'inline-flex', flexDirection: emLinha ? 'row' : 'column',
        alignItems: 'flex-start', gap: emLinha ? 10 : 0, textAlign: 'left', lineHeight: 1.5,
      }}
    >
      <Tooltip title="Trabalhei de casa ou remoto neste dia" mouseEnterDelay={0.6}>
        <Checkbox checked={remoto} style={caixa} onChange={(e) => onMudar('remoto', e.target.checked)}>
          Home office
        </Checkbox>
      </Tooltip>
      <Tooltip title="Fui a campo neste dia" mouseEnterDelay={0.6}>
        <Checkbox checked={campo} style={caixa} onChange={(e) => onMudar('campo', e.target.checked)}>
          Campo
        </Checkbox>
      </Tooltip>
    </div>
  );
}
